import { COUNTRY } from '../../../../../utils/constants'
import { createGenericSlice } from '../../../../../utils/slices'

export const settingsSlice = createGenericSlice({
  name: 'settings',
  initialState: {
    country: COUNTRY.USA,
    isUSA: true,
  },
  reducers: {
    changeSettings: (state, action) => {
      return { ...state, ...action.payload }
    },
  },
})

export const settingsActions = settingsSlice.actions
